import { css } from 'styled-components';
import {
  primaryBrandButtonLarge,
  secondaryBrandButtonSmall,
  tertiaryBrandButtonSmall,
} from 'components/Globals/Base/Button/buttonStyles';
import { brandGrayLink } from 'components/Globals/Base/Link/LinkStyles';
import { breakpoint, font } from 'styles/globals';
import type { Theme } from 'styles/theme';

export const readOurReviews = css<{ theme: Theme }>`
    .read-our-reviews-widget {
      display: flex;
      flex-direction: column;

      h2 {
        font-family: ${font.saolText};
        font-size: 32px;
        font-weight: 600;
        line-height: 120%;
        margin: 0;
        margin-bottom: 24px;
        text-align: left;
      }

      [role="tablist"]:not(:last-child) {
        margin-bottom: 32px;
      }

      [role="tabpanel"]:not(.is-hidden) {
        display: flex;
        flex-direction: column;
        gap: 32px;
        padding-top: 0;
      }

      @media (${breakpoint.mdMin}) {
        [role="tabpanel"]:not(.is-hidden) {
          gap: 24px;
        }

        [role="tablist"]:not(:last-child) {
          margin-bottom: 24px;
        }
      }

      & > a {
        ${primaryBrandButtonLarge}
        align-self: flex-end;
        width: 100%;
      }


      @media (${breakpoint.mdMin}) {
        & > a {
          width: auto;
        }
      }
    }


    .review-card-widget {
        display: grid;
        grid-template-columns: 120px 1fr;
        gap: 16px;

        .wp-block-image > *:not(img) {
          display: none;
        }

        h3, p {
          margin: 0;
          font-family: ${font.graphikCond};
          font-size: 14px;
          font-weight: 400;
          line-height: 120%;
          letter-spacing: 0.5px;
        }

        h3 {
          font-weight: 600;
          font-size: 18px;
        }

        // image
        & > *:nth-child(1) {
          grid-column: 1;
          grid-row: 2;
          p {
            font-size: 12px;
            text-align: center;
            margin-top: 4px;
            a {
              ${brandGrayLink}
            }
            &:empty {
              display: none;
            }
          }
        }

        // title
        & > *:nth-child(3) {
          grid-column: span 2;
          grid-row: 1;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
        }
        
        // description
        & > *:nth-child(4) {
          font-family: ${font.graphikCompact};
          grid-column: 2;
          grid-row: 2;
        }
        
        // cta
        & > *:nth-child(2) {
          grid-column: span 2;
          grid-row: 3;
          display: flex;
          align-items: center;
          justify-content: right;
          a {
            &:not(.link) {
              ${secondaryBrandButtonSmall}
            }
            &.link {
              ${tertiaryBrandButtonSmall}
              font-size: 14px;
            }
            width: 100%;
          }
          &:empty {
            display: none;
          }
        }

        @media (${breakpoint.mdMin}) {
          display: grid;
          grid-template-columns: 164px 1fr auto;
          grid-template-rows: 1fr auto auto 1fr;
          gap: 0 24px;

          // image
          & > *:nth-child(1) {
            grid-column: 1;
            grid-row: 1 / span 4;
            p {
              font-size: 14px;
            }
          }

          // title
          & > *:nth-child(3) {
            grid-column: 2;
            grid-row: 2;
            display: block;
          }

          // description
          & > *:nth-child(4) {
            grid-row: 3;
          }

          // cta
          & > *:nth-child(2) {
            grid-column: 3;
            grid-row: 1 / span 4;
            a {
              width: auto;
            }
          }
        }
    }
`;
